import { useEffect, useState, useCallback, ChangeEvent, FormEvent, useMemo } from "react";
import { MRT_ColumnDef } from "material-react-table";

import MATERIAL_TABLE_CONTAINER from "../../../main_components/material_table/table_container";


export default function SUPPLIER_INVOICE(props: any) {
    const [invoice, setInvoice] = useState<any>([]);

    console.log("invoice", invoice); 
    console.log("invoice", props?.invoice); 

    const columns: MRT_ColumnDef<any>[] = useMemo(
        () => [

            {
                id: "invoice_date",
                header: "Fecha",
                accessorKey: "invoice_date",
            },

            {
                header: "Serie",
                accessorKey: "serie",
                id: "serie",
            },
            {
                id: "folio",
                header: "Folio",
                accessorKey: "folio",
            },
            {
                header: "Cliente",
                accessorKey: "name_business_partner",
                id: "name_business_partner"
            },
            {
                header: "RFC",
                accessorKey: "rfc_business_partner",
                id: "rfc_business_partner"
            },

            {
                id: "subtotal",
                header: "Subtotal",
                accessorKey: "subtotal",
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableFooterCellProps: {
                    align: 'right',
                },
            },
            {
                id: "discount",
                header: "Descuento",
                accessorKey: "discount",

                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableFooterCellProps: {
                    align: 'right',
                },
            },
            {
                id: "tax",
                header: "Impuesto",
                accessorKey: "tax",
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableFooterCellProps: {
                    align: 'right',
                },
            },
            {
                id: "total",
                header: "Total",
                accessorKey: "total",
                muiTableBodyCellProps: {
                    align: 'right',
                },
                muiTableFooterCellProps: {
                    align: 'right',
                },
            },
        ],
        [invoice]
    );


    useEffect(() => {
        setInvoice(props?.invoice);
    }, [props?.invoice]);

    return (
        <div>
            <MATERIAL_TABLE_CONTAINER
                key={"ORDERS"}
                columns={columns}
                data={invoice}
                breadcrumbs={props?.breadcrumbs?[{ label: "FACTURA SUBIDA", path: null }]:null}
                modalT={false}
                isLoading={false}
                search_filters={<div></div>
                }
                component_header={
                    <div></div>
                }
                file_name_export="FACTURAS"
                update_identifiers={[]}
            ></MATERIAL_TABLE_CONTAINER>

        </div>
    );
}
